import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories } from '@/mocks/categories';
import { softwares } from '@/mocks/softwares';
import useDocumentMeta from '@/hooks/useDocumentMeta';

export default function AboutPage() {
  useDocumentMeta({
    title: '关于我们 - 黄金网站软件app免费',
    description:
      '黄金网站软件app免费专注黄金投资软件与应用的整理推荐，涵盖行情分析、价格走势与理财工具，帮助用户高效掌握黄金资讯。',
    keywords: '黄金网站软件app免费,关于我们,黄金投资软件推荐',
  });

  const totalDownloads = softwares.reduce((sum, s) => sum + s.downloads, 0);

  return (
    <SiteLayout>
      <Breadcrumb items={[{ label: '关于我们' }]} />

      <section className="rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
        <h1 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          关于黄金网站软件app免费
        </h1>
        <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-4xl">
          黄金网站软件app免费是一个专注黄金投资领域的软件与应用信息聚合站点。我们围绕黄金市场行情、价格走势监控与黄金理财工具，
          为关注黄金投资的用户整理并推荐实用的软件资源，帮助大家用更高效的工具掌握黄金资讯、辅助投资决策。
        </p>

        <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {[
            { icon: 'ri-apps-2-line', label: '收录软件', value: `${softwares.length} 款` },
            { icon: 'ri-folder-open-line', label: '功能分类', value: `${categories.length} 类` },
            {
              icon: 'ri-download-2-line',
              label: '累计下载',
              value: `${(totalDownloads / 10000).toFixed(1)} 万+`,
            },
          ].map((item) => (
            <div key={item.label} className="rounded-lg bg-background-100 border border-background-200 p-5">
              <span className="w-10 h-10 rounded-md bg-secondary-950 text-primary-400 flex items-center justify-center">
                <i className={`${item.icon} text-xl`} />
              </span>
              <p className="mt-3 font-heading text-xl font-bold text-foreground-950">{item.value}</p>
              <p className="mt-1 text-sm text-foreground-500">{item.label}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 rounded-lg border border-background-200 bg-background-50 p-6">
          <h2 className="font-heading text-lg font-bold text-foreground-950">我们提供的内容</h2>
          <ul className="mt-4 flex flex-col gap-4">
            {[
              {
                icon: 'ri-line-chart-line',
                title: '黄金市场行情分析',
                desc: '整理趋势分析、技术指标与K线形态类工具，帮助判断价格的中短期方向。',
              },
              {
                icon: 'ri-radar-line',
                title: '价格走势监控',
                desc: '收录实时盯盘与到价提醒类应用，随时掌握金价波动与关键点位。',
              },
              {
                icon: 'ri-wallet-3-line',
                title: '黄金理财工具',
                desc: '涵盖定投计算、收益测算与资产配置工具，辅助稳健打理黄金类资产。',
              },
              {
                icon: 'ri-newspaper-line',
                title: '行情资讯学习',
                desc: '聚合市场快讯、机构研报与入门课程，帮助新手快速建立投资认知。',
              },
            ].map((item) => (
              <li key={item.title} className="flex items-start gap-3">
                <span className="w-10 h-10 rounded-md bg-primary-100 text-primary-800 flex items-center justify-center shrink-0">
                  <i className={`${item.icon} text-xl`} />
                </span>
                <div>
                  <h3 className="font-semibold text-sm text-foreground-950">{item.title}</h3>
                  <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 p-6">
          <h2 className="font-heading text-lg font-bold text-foreground-950">联系方式</h2>
          <ul className="mt-4 flex flex-col gap-4 text-sm">
            <li className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-md bg-background-100 text-primary-700 flex items-center justify-center shrink-0">
                <i className="ri-mail-line text-lg" />
              </span>
              <div>
                <p className="text-foreground-500 text-xs">邮箱</p>
                <p className="text-foreground-900">support@gold-software.example.com</p>
              </div>
            </li>
            <li className="flex items-center gap-3">
              <span className="w-9 h-9 rounded-md bg-background-100 text-primary-700 flex items-center justify-center shrink-0">
                <i className="ri-time-line text-lg" />
              </span>
              <div>
                <p className="text-foreground-500 text-xs">服务时间</p>
                <p className="text-foreground-900">周一至周五 09:00 - 18:00</p>
              </div>
            </li>
          </ul>

          <h3 className="mt-6 text-sm font-semibold text-foreground-900">关注我们</h3>
          <div className="mt-3 flex items-center gap-3">
            {[
              { icon: 'ri-wechat-line', label: '微信' },
              { icon: 'ri-weibo-line', label: '微博' },
              { icon: 'ri-telegram-line', label: 'Telegram' },
            ].map((s) => (
              <span
                key={s.icon}
                className="w-10 h-10 rounded-md bg-background-100 border border-background-200 flex items-center justify-center text-foreground-600 cursor-pointer hover:bg-primary-500 hover:text-secondary-950 hover:border-primary-500 transition-colors"
                title={s.label}
              >
                <i className={`${s.icon} text-lg`} />
              </span>
            ))}
          </div>

          <Link
            to="/softwares"
            className="mt-6 h-11 rounded-md bg-primary-500 hover:bg-primary-600 text-secondary-950 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors flex items-center justify-center gap-2"
          >
            浏览全部软件
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line text-base" />
            </span>
          </Link>
        </div>
      </section>

      <section className="mt-6 rounded-lg border border-background-200 bg-secondary-950 p-6 md:p-8 text-background-200">
        <h2 className="font-heading text-lg font-bold text-background-50">版权与免责说明</h2>
        <div className="mt-4 flex flex-col gap-3 text-sm leading-relaxed">
          <p>
            本站为演示性质的信息聚合站点，页面中收录的软件名称、简介、版本与下载信息均为示例内容，
            相关下载链接均为示范地址，<strong className="text-background-50">不提供真实下载服务</strong>。
          </p>
          <p>
            所有软件版权归其开发者或官方发布方所有，请以软件官方网站发布的最新版本为准。
            用户在下载与安装任何第三方软件前，应自行核对来源的合法性与安全性。
          </p>
          <p>
            本站内容仅供参考，不构成任何投资建议。黄金及贵金属投资存在市场风险，请理性判断、谨慎决策。
          </p>
          <p className="text-background-400 text-xs pt-2 border-t border-secondary-800">
            如需更正或下架相关信息，请通过上方邮箱与我们联系。
          </p>
        </div>
      </section>
    </SiteLayout>
  );
}